import ImageWithBasePath from "@/components/image-with-base-path"


const ChooseUsSection = () => {
  return (
   <>
  {/* Start Why Choose Us Section */}
  <section className="section whychoose-section-fifteen">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6">
          <div
            className="why-choose-img pe-5 d-none d-lg-block wow fadeInUp"
            data-wow-duration="2s"
          >
            <ImageWithBasePath
              src="assets/img/features/choose-img-1.png"
              alt="img"
              className="img-fluid img-1"
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="why-choose-content">
            <div
              className="section-header section-header-fifteen wow fadeInUp"
              data-wow-duration="2s"
            >
              <div className="section-sub-title">Why Choose Us</div>
              <h2 className="section-title">
                Helping You Heal with <br /> Care &amp;{" "}
                <span>Understanding</span>
              </h2>
            </div>
            <div
              className="choose-item-fifteen wow fadeInUp"
              data-wow-duration="2s"
            >
              <div className="choose-icon">
                <ImageWithBasePath
                  src="assets/img/icons/choose-icon-5.svg"
                  alt="icon"
                  className="img-fluid icon"
                />
              </div>
              <div className="choose-text">
                <h3 className="choose-title">
                  Compassionate, Judgment-Free Environment
                </h3>
                <p className="choose-description">
                  Safe, supportive space to share openly without fear or
                  judgment.
                </p>
              </div>
            </div>
            <div
              className="choose-item-fifteen wow fadeInUp"
              data-wow-duration="2s"
            >
              <div className="choose-icon">
                <ImageWithBasePath
                  src="assets/img/icons/choose-icon-6.svg"
                  alt="icon"
                  className="img-fluid icon"
                />
              </div>
              <div className="choose-text">
                <h3 className="choose-title">
                  Licensed and Experienced Professionals
                </h3>
                <p className="why-choose-description">
                  Certified professionals providing expert care tailored to
                  individual needs.
                </p>
              </div>
            </div>
            <div
              className="choose-item-fifteen wow fadeInUp"
              data-wow-duration="2s"
            >
              <div className="choose-icon">
                <ImageWithBasePath
                  src="assets/img/icons/choose-icon-7.svg"
                  alt="icon"
                  className="img-fluid icon"
                />
              </div>
              <div className="choose-text">
                <h3 className="choose-title">
                  Confidential and Secure Sessions
                </h3>
                <p className="why-choose-description">
                  Private, secure sessions ensuring confidentiality and complete
                  peace of mind.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ImageWithBasePath
      src="assets/img/bg/about-img-two.png"
      alt="about"
      className="img-fluid element-1"
    />
  </section>
  {/* End Why Choose Us Section */}
</>

  )
}

export default ChooseUsSection